import React from "react";
import {Box} from '@mui/material';
import CustomAppBar from '../components/appbar';
import ApplicationVideos from "../components/Applicationvideos";

const Vids = () => {
    return (
        <Box>
            <CustomAppBar active="application"/>
            <ApplicationVideos/>
        </Box>
    );
}

export default Vids;